<script lang="ts">
  import Header from '../components/layout/Header.svelte';
  import Footer from '../components/layout/Footer.svelte';
</script>

<div class="relative flex h-auto min-h-screen w-full flex-col overflow-x-hidden">
  <Header />

  <main class="flex-1 flex flex-col items-center w-full py-8 px-4 md:px-10">
    <div class="max-w-[780px] w-full flex flex-col gap-8">
      <!-- Page Title -->
      <div class="flex flex-col gap-2 pb-6 border-b border-gray-200/60">
        <div class="flex items-center gap-2 text-sm">
          <a href="/" class="text-[#617589] hover:underline">Home</a>
          <span class="text-[#617589]">/</span>
          <span class="text-[#111418] font-medium">Privacy Policy</span>
        </div>
        <h1 class="text-[#111418] text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">Privacy Policy</h1>
        <p class="text-[#617589] text-base font-normal leading-normal">Last updated: February 3, 2026</p>
      </div>

      <!-- Content -->
      <div class="flex flex-col gap-6 text-[#111418] text-base leading-relaxed">

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">1. Overview</h2>
          <p class="text-[#617589]">
            EazyCalculators is a free, browser-based calculator platform. This Privacy Policy explains what information we collect, how we use it, and the choices available to you. Because all calculations run entirely in your browser, we collect minimal data by design.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">2. Information We Collect</h2>
          <p class="text-[#617589]">We do not collect or store any calculation inputs or results.</p>
          <p class="text-[#617589]font-medium mt-1">We may automatically receive standard server logs that include:</p>
          <ul class="list-disc list-inside text-[#617589] ml-2 flex flex-col gap-1">
            <li>Your IP address</li>
            <li>Browser type and version</li>
            <li>Pages visited and time spent</li>
            <li>Referring URL</li>
            <li>Date and time of visits</li>
          </ul>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">3. How We Use Information</h2>
          <p class="text-[#617589]">The limited information we receive through server logs may be used to:</p>
          <ul class="list-disc list-inside text-[#617589] ml-2 flex flex-col gap-1">
            <li>Monitor site health and performance</li>
            <li>Investigate and respond to security incidents</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p class="text-[#617589] mt-1">We do not use any collected information for advertising, profiling, or marketing purposes.</p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">4. Cookies and Tracking</h2>
          <p class="text-[#617589]">
            EazyCalculators does not use cookies, tracking pixels, or any third-party analytics tools. No persistent identifiers are stored on your device by our application.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">5. Data Sharing</h2>
          <p class="text-[#617589]">
            We do not sell, trade, or share any information with third parties. The only exception is if we are required to do so by law or to protect the security of our site.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">6. Data Retention</h2>
          <p class="text-[#617589]">
            Server logs are automatically purged after 30 days. No other user data is stored on our systems.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">7. Your Rights</h2>
          <p class="text-[#617589]">
            Because we do not collect personal accounts or store calculation data, there is no personal data profile to access, correct, or delete. If you have concerns about server log data, you may contact us and we will assist to the extent possible.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">8. Changes to This Policy</h2>
          <p class="text-[#617589]">
            We may update this Privacy Policy from time to time. Any changes will be reflected by updating the date at the top of this page. Continued use of EazyCalculators after a change constitutes acceptance of the updated policy.
          </p>
        </section>

<!--        <section class="flex flex-col gap-2">-->
<!--          <h2 class="text-xl font-bold">10. Contact Us</h2>-->
<!--          <p class="text-[#617589]">-->
<!--            If you have any questions about this Privacy Policy, please reach out to us at <span class="text-primary">support@eazycalculators.net</span>.-->
<!--          </p>-->
<!--        </section>-->

      </div>
    </div>
  </main>

  <Footer />
</div>
